import mediumZoom from 'medium-zoom';
mediumZoom('[data-zoomable]', { background: undefined });
